import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initState = {
  // Curriculum Pointers
  curriculums: {},
  levelIndex: 0,
  questionIndex: 0,
  questionIdsInRound: [],

  progressAmount: 0,
  selectedResponse: undefined,
  recordingUrls: [],
};

const roundPlayReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.FETCH_CURRICULUMS_FULLFILLED:
      return {
        ...state,
        curriculums: payload,
      };
    case REDUX_ACTIONS.SET_LEVEL_INDEX:
      return {
        ...state,
        levelIndex: payload,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
      return {
        ...state,
        questionIdsInRound: payload.questionIdsInRound,
        questionIndex: 0,
        progressAmount: 0,
        selectedResponse: undefined,
      };

    case REDUX_ACTIONS.NEXT_STANDARD_ITEM:
      return {
        ...state,
        progressAmount: state.questionIndex === state.questionIdsInRound.length - 1 ?
          100 :
          state.progressAmount + (100 / state.questionIdsInRound.length),
        questionIndex: Math.min(state.questionIndex + 1, state.questionIdsInRound.length - 1),
      };

    case REDUX_ACTIONS.SAVE_RECORDING_URL:
      return {
        ...state,
        recordingUrls: [...state.recordingUrls, payload],
      };
    case REDUX_ACTIONS.RESET_RECORDING_URLS:
      return {
        ...state,
        recordingUrls: [],
      };

    case REDUX_ACTIONS.SAVE_FLUENCY_RESULTS:
      return {
        ...state,
        fluencyResults: payload,
      };

    default:
      return state;
  }
};

export default roundPlayReducer;
